import React from "react";

interface IContactInputProps {
  id?: string;
  inputLabel?: string;
  inputType?: string;
  placeHolder: string;
  testId?: string;
  error?: string;
  value: string | number;
  onChange: (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => void;
}
const inputCSS =
  "border border-solid border-grey-300 rounded-lg py-3 px-3 focus:outline-none focus:ring-2 focus:ring-brand focus:ring-opacity-40";

const ContactInput = ({
  inputLabel = "",
  inputType,
  testId,
  id,
  placeHolder,
  error,
  onChange,
  value = "",
}: IContactInputProps) => {
  return (
    <div className="py-5 flex flex-col">
      <label htmlFor={id} className=" pb-1 font-medium text-sm text-mediumgrey capitalize">
        {inputLabel}
      </label>
      {inputType === "textarea" ? (
        <textarea
          data-testid={testId}
          id={id}
          onChange={onChange}
          value={value}
          className={`min-h-[74px] ${inputCSS}`}
          placeholder={placeHolder}
        />
      ) : (
        <input
          data-testid={testId}
          type={inputType}
          id={id}
          onChange={onChange}
          value={value}
          className={`h-12 ${inputCSS}`}
          placeholder={placeHolder}
        />
      )}
      {error && <p className="text-error py-2">{error}</p>}
    </div>
  );
};

export default ContactInput;
